module.exports = __webpack_public_path__ + "static/media/pensions-1.ca3225f7.svg";